export default [
  {
    path: '/driver-invoices',
    name: 'driver-invoice-list',
    component: () => import('@/views/driverInvoices/DriverInvoiceList.vue'),
    meta: {
      requireLogin: true,
      roles: ['admin', 'superadmin', 'admin_developer', 'accountant', 'delivery_man', 'pickupeur'],
      pageTitle: 'Factures Livreurs',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Factures Livreurs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/driver-invoices/:id',
    name: 'driver-invoice-detail',
    component: () => import('@/views/driverInvoices/DriverInvoiceDetail.vue'),
    meta: {
      requireLogin: true,
      roles: ['admin', 'superadmin', 'admin_developer', 'accountant', 'delivery_man', 'pickupeur'],
      pageTitle: 'Détail Facture Livreur',
      breadcrumb: [
        {
          text: 'Tableau de bord',
          to: { name: 'dashboard' },
        },
        {
          text: 'Factures Livreurs',
          to: { name: 'driver-invoice-list' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
    },
  },
]
